import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Loading from '../atoms/Loading';
import Textlink from '../atoms/link/Textlink';
import LineTitle from '../atoms/titles/LineTitle';
import LineTitleGray from '../atoms/titles/LineTitleGray';
import Tag from '../atoms/tag/Tag';
import PlanInfo from '../organisms/PlanInfo';
import {
  makeAdditionalParamsPlanList,
  makeAdditionalParamsPlanDetail,
  makeQueryStringsWithDuplicatedSessionKey,
} from '../../utils/queryParams';
import RoomDetail from '../molecules/RoomDetail';
import { BASENAME, ENABLE_MULTIPLE_HOTEL_PLAN } from '../../constants';
import { usePrice } from '../../utils/price';
import PlanningInfo from '../molecules/PlanningInfo';
import { FData } from '../Head';
import ModalOtherPage from '../modal/ModalOtherPage';
import { getSelectedPlanOptionsState } from '../../utils/localStorage';
import { sessionKey } from '../../modules/app';


const FEMALE_TAG_ID = 'female_only';

const selector = (state) => ({
  flight: state.flight,
  hotel: state.hotel,
  planDetail: state.planDetail,
});

const PlanDetail = ({
  handlePlanSelect, selectedPlan, hidePlanListLink, handlePlanListLinkBottom, handlePlanListLink, editingAccommodation = false
}) => {
  const { flight: flightState, hotel: hotelState, planDetail } = useSelector(selector);
  const [ activePhotoIndex, setActivePhotoIndex ] = useState(0);


  const { plans } = planDetail;
  const plan = selectedPlan ? selectedPlan : plans && plans.length && plans[0].plan;

  const { searchedFlightsInput, selectedOutboundFlight, selectedInboundFlight, selectedOutboundDate } = flightState;
  const { searchedHotelsInput } = hotelState;

  // localStorageからplanOptionsを取得
  const planOptionsFromStorage = getSelectedPlanOptionsState(sessionKey);
  const selectedPlanOptions = Array.isArray(planOptionsFromStorage) ? planOptionsFromStorage : [];

  const [showPlanDetailModal, setShowPlanDetailModal] = useState(false);

  // TODO
  // Error Handling

  if (!plan) {
    return <Loading show progressRate={50} />;
  }

  const {
    id: planId,
    name: planName,
    stocks,
    // stockStatus,
    recommendationPoint,
    mealCondition,
    planningImplementation,
    roomType,
    room,
    hotel,
    tags: planTags,
    femaleOnlyPlan,
    commentInfo,
    mealInfo,
    chargesRemarks,
    chargesInfantRemarks,
    earlyCheckInTime,
    lateCheckOutTime,
    omotenashiInfo,
    landingFlag,
    totalAmountPerPerson,
    otherItinerary,
  }= plan;
  const guidance = `<div>
  <div>■基本代金について</div>
  <p>
  ・基本代金は、往復航空機＋宿泊代金となります。（サービス料・消費税等諸税（宿泊税・入湯税※）含む）<br />
  　搭乗便、搭乗時間、発着地によって旅行代金が異なる場合があります。<br />
  　※課税対象地域・施設のみ含みます。<br />
  　表示されている基本代金・プラン内容は一定時間ごとに更新されます。お申込み手続きの【お申込み内容の最終確認】画面にて、旅行代金・プラン内容をご確認ください。<br />
  ・タビサキMenuは基本代金に含まれます。お客様の都合でご利用されない場合でも返金はありません。<br />
  　連泊の場合でも特に明記のない限り、タビサキMenuは滞在中1回のみとなります。<br />
  ※表示している合計料金は、タビサキMenu利用料金をすべておとな代金で加算しております。各メニューの人員種別を選択の上お申込内容の最終確認画面にて旅行代金をご確認ください。
  </p>
  <div>■参加人員について</div>
  <table><tbody>
  <tr><td>おとな（12歳以上）</td><td>：</td></td><td>座席あり／寝具あり</td></tr>
  <tr><td>こどもA（6～11歳）</td><td>：</td></td><td>座席あり／寝具あり</td></tr>
  <tr><td>こどもB（3～5歳）</td><td>：</td></td><td>座席あり／寝具あり</td></tr>
  <tr><td>こどもC（2～5歳）</td><td>：</td></td><td>座席なし／寝具なし</td></tr>
  <tr><td></td></td><td></td><td>座席あり／寝具なし</td></tr>
  <tr><td>こどもD（0～1歳）</td><td>：</td></td><td>座席なし／寝具なし</td></tr>
  </tbody></table>
  <p>
  ※6歳以上のお子様は寝具なし（添い寝）のご予約はお取扱できません。<br />
  　こども(0～5歳)は寝具なし（添い寝）のご予約が可能です。<br />
  　但し、こども（3～5歳）は航空座席が必要です。また2026/05/19搭乗分からの全日空(ANA)・エアドゥ(ADO)・<br />
  　ソラシドエア(SNA)・スターフライヤー(SFJ)便をご利用の場合は、2歳のお子様から航空座席が必要となります。<br />
  ※「こどもC」「こどもD」は、施設により年齢設定が異なります。幼児代金備考にてご確認ください。<br />
  </p>
  <p>・食事付プランの場合</p>
  <table><tbody>
  <tr><td>こどもA（小学生）</td><td>：</td></td><td>おとな同様</td></tr>
  <tr><td>こどもB（未就学児・小学生）</td><td>：</td></td><td>少なめ</td></tr>
  <tr><td>こどもC（未就学児）</td><td>：</td></td><td>食事なし</td></tr>
  <tr><td>こどもD（未就学児）</td><td>：</td></td><td>食事なし</td></tr>
  </tbody></table>
  <p>※こどもBは施設により年齢設定が異なり、プランによって設定がない場合があります。旅行代金備考にてご確認ください。</p>
  <p>
  ・同行できるこどもC・こどもD（添い寝幼児）の人員数は、原則おとなの人員数以下です。おとな2名様以上の同伴が必要です。<br />
  ・プラン・部屋条件(ベッド幅が狭いセミダブルルーム等)やお子様の年齢によりお受けできない場合があります。<br />
  ・「こどもD（添い寝幼児）」は、幼児施設使用料等（現地払い）がかかる場合があります。各宿泊施設により異なりますので、幼児代金備考にてご確認下さい。<br />
  ・幼児施設使用料に含まれるものは、各宿泊施設により異なります。
  </p>
  <p>【重要】必ずお読みください。</p>
  <p>
  ■旅行期間：2日間～最大8日間。<br />
  ※検索画面にて指定した旅行期間は変更できません。変更をおこなう場合は、再度検索画面からお申し込みください。
  </p>
  <p>■旅行行程：宿泊につきましてはご出発日の1泊目は必須となります。${ENABLE_MULTIPLE_HOTEL_PLAN ? '旅行期間内に異なる施設の宿泊を希望される場合には、行程確認画面で宿泊行程の追加を行ってください。' : ''}</p>
  <p>
  ■最少催行人員：1名様（おとな1名様よりお申込みを受付）<br />
  ※一部コースは2名様。<br />
  お申込み人数：1名様～6名様、往復同一行程（発着空港・搭乗便）でのご利用となります。<br />
  </p>
  <p>
  ■施設情報について<br />
  施設の情報として記載している各種料金・案内等は施設からの情報を基にしています。予告なく変更となる場合がありますので、事前に各施設にご確認されることをお勧めいたします。<br />
  また、「プラスチック資源循環促進法（2022年4月施行）」により、客室のアメニティ類に変更が生じる場合がございます。
  </p>
  <p>
  ■お部屋について<br />
  ・部屋タイプにより、一部補助ベッド(エキストラ・ソファーベッド等)を使用することがあります。その場合お部屋が手狭になったりベッドの運び込みが遅くなる場合があります。<br />
  ・お申込み人員を超えての補助ベッドのご用意はありません。<br />
  ・眺望・階層・部屋タイプ・広さ等を限定したプラン以外は、お部屋は宿泊施設にて一任させていただきます。お客様の指定は承れません。<br />
  ・宿泊日により、客室定員内であっても、設定がない場合があります。<br />
  ・こどもC・こどもD（添い寝幼児）のお子様は、室内備品(タオルやアメニティ等)は提供されません。
  </p>
  <p>
  ■お食事付プランについて<br />
  ・施設の夕食提供時間終了以降のチェックイン、及び朝食提供時間前の早朝チェックアウトの場合、食事の提供はできません。また返金もございません。食事提供時間については、各宿泊施設へお問い合わせください。<br />
  ・同一宿泊施設で連泊される場合、2泊目のお食事内容は掲載内容と異なる場合があります。<br />
  ・お食事場所について複数の箇所が記載されている場合、原則としてお選びいただけません。<br />
  ・メニュー及び食事時間の選択が可能なプランについては、特に明記のない限りお申込グループ単位での選択となります。<br />
  ・繁忙期間は、料理内容が記載内容と異なる場合があります。<br />
  ・食事内容がバイキングの場合、こどもA・こどもBとも大人と同内容となります。
  </p>
  <p>
  ■施設からのお楽しみメニュー付プランについて<br />
  ・お楽しみメニューは旅行代金に含まれます。お客様の都合でご利用されない場合でも返金はありません。<br />
  ・連泊の場合でも特に明記のない限り、お楽しみメニューは滞在中1回のみとなります。
  </p>
  <p>
  ■添乗員・現地係員が同行しない個人旅行です。<br />
  本プランでは約款に定める旅程管理は行いません。ご旅行中の諸手続きはお客様ご自身で行なっていただきます。
  </p>
  <p>
  ■ご案内<br />
  ・18歳未満のお客様のみでの参加には、親権者の方の同意が必要です。<br />
  ・特別な配慮・措置が必要となる可能性がある方は、お申込内容の最終確認画面の「特別な配慮を必要とする方のお申込みについて」でご選択の上、取扱店舗へお申し出ください。なお、食事等のアレルギーについてのご相談がある場合は、宿泊施設へ直接お申し出ください。
  </p>
</div>`;

  const { id: roomTypeId, name: roomTypeName } = roomType;

  const {
    id: hotelId,
    name: hotelName,
    imageURLs,
    detailURL,
    mapURL,
    area,
    // recommendationPoint,
    checkInfo,
    tags: hotelTags,
    message,
    specialMeasures,
  } = hotel;
  const planDetaillink = detailURL;

  let tags = [...hotelTags, ...planTags];
  if (femaleOnlyPlan) {
    const femaleTag = {
      id: FEMALE_TAG_ID,
      name: '女性限定',
      tagGroup: {},
    };

    tags.push(femaleTag);
  }

  const { checkin, checkout } = checkInfo;
  const checkInDisplay = !checkin ? '※詳細は施設へお問合せください。'
    : (earlyCheckInTime && earlyCheckInTime !== checkin)
      ? `${earlyCheckInTime} (通常${checkin})` : checkin;
  const checkOutDisplay = !checkout ? '※詳細は施設へお問合せください。'
    : (lateCheckOutTime && lateCheckOutTime !== checkout)
      ? `${lateCheckOutTime} (通常${checkout})` : checkout;

  const {
    prefectureName,
    districtName,
  } = area;

  const { outbound, people } = searchedFlightsInput;
  const { stayNights } = searchedHotelsInput;

  const paramsPlanList = makeAdditionalParamsPlanList(hotelId);

  const { subtitle, usage, explanation } = otherItinerary;

  const handleClickButton = () => {
    if (!plan) {
      return;
    }

    if (handlePlanSelect) {
      return handlePlanSelect(plan);
    }

    // プランに着地が紐づいている場合は着地選択画面へ遷移し、紐づいていない場合は内容確認画面へ遷移する
    const planDetailParams = makeAdditionalParamsPlanDetail(planId, roomTypeId);
    const searchConfirm = makeQueryStringsWithDuplicatedSessionKey(planDetailParams);
    const entryConfirmLink = `${BASENAME}/entry_confirm?${searchConfirm}`;
    const landLink = `${BASENAME}/plan_option?${searchConfirm}`;
    if(landingFlag){
      window.open(landLink, '_self');
    }else{
      window.open(entryConfirmLink, '_self');
    }
  };

  let totalAmount = 0;
  let adultPrice = 0;
  if (plan) {
    const { totalPrice, totalPriceIncludePlanOption, pricePerAdult } = usePrice(
      people, 
      selectedOutboundFlight, 
      selectedInboundFlight, 
      selectedPlan ? [
        ...plans.map(p => {
          return p.plan;
        }).filter(Boolean),
        plan,
      ] : [plan],
      selectedOutboundDate,
      selectedPlanOptions
    );
    totalAmount = selectedPlanOptions.length > 0 ? totalPriceIncludePlanOption : totalPrice;
    adultPrice = pricePerAdult;
  }

  const activePhotoURL = imageURLs && imageURLs.length && imageURLs[activePhotoIndex];

  // workaround https://gitlab.fqsv.net/dp-plus/front/issues/104 cant use <a>tag
  // const onClickDetailLink = () => {
  //   window.open(detailURL, '_blank');
  // };
  const onClickDetailLink = () => setShowPlanDetailModal(true);
  const onCloseDetailModal = () => setShowPlanDetailModal(false);

  const handlePlanListLinkSpan = () => {
    if (handlePlanListLink && editingAccommodation) {
      handlePlanListLink();
    }else{
      const search = makeQueryStringsWithDuplicatedSessionKey(paramsPlanList);
      const planListLink = `${BASENAME}/plan_list?${search}`;
      window.open(planListLink, '_self');
    }
  };

  const handlePlanListLinkBottomSpan = () => {
    if (handlePlanListLinkBottom && editingAccommodation) {
      handlePlanListLinkBottom();
    }else{
      const search = makeQueryStringsWithDuplicatedSessionKey(paramsPlanList);
      const planListLink = `${BASENAME}/plan_list?${search}`;
      window.open(planListLink, '_self');
    }
  };

  const isWDS = plan.tieupCompCD === 'WDS';

  return (
    <div className="pagePlanDetail">
      <FData action="detail" flightState={flightState} plnaDetailState={planDetail} />
      <header className="header">
        <div className="headerTop">
          <div className="headerTopItems">
            <div className="headerTopLeft">
              <h1 className="h1">{hotelName}</h1>
              <div className="area isPC">{prefectureName}／{districtName}</div>
              <div className="isSP facilitySup">
                <div className="facilitySupArea">{prefectureName}／{districtName}</div>
                <div className="facilitySupInfoItems">
                  <div className="facilitySupInfoItem">
                    <Textlink onClick={onClickDetailLink}>施設詳細</Textlink>
                  </div>
                </div>
              </div>
            </div>
            <div className="headerTopRight isPC">
              <Textlink onClick={onClickDetailLink}>施設詳細</Textlink>
            </div>
          </div>
          {specialMeasures && (
            <div className="specialMeasures planDetail">
              <div className="pr_label_wrap">
                <link href="https://ecwww9.nta.co.jp/test_search/style.css" rel="stylesheet" media="all" />
                <ul className="pr_label">
                  <li className="pr_icon_01">{specialMeasures}</li>
                </ul>
              </div>
              <span className="note">必ず<a href="https://www.nta.co.jp/kokunai/special/ouen/kyushu/" target="_blank">ご利用条件・ご案内</a>をご確認の上、お申込みください。</span>
            </div>
          )}
          <div className="headerTopItems positionPointSP">
            <div className="headerTopLeft">
              <LineTitle>
                <span className="courseName">{planName}</span>
                <br className="isSP" />
                {/* https://gitlab.fqsv.net/dp-plus/front/issues/144 */}
                {/* <span className="courseCode">［コースコード］{plan && plan.id}</span> */}
              </LineTitle>
            </div>
            {!hidePlanListLink && (
              <div className="headerTopRight">
                <div className={`textLinkWrap clickable`}>
                  <span className={`textLink`} onClick={handlePlanListLinkSpan}>
                    プラン一覧
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
      <div className="body">
        <div className="planDetailThumbnail">
          <LineTitleGray>プラン詳細</LineTitleGray>
          <div className="planDetailThumbnailBody">
            <div className="thumbnail">
              <div className="thumbnailImage">
                <img src={activePhotoURL} alt="" />
              </div>
              <div className="subImages">
                {imageURLs && imageURLs.map((imageURL, index) => (
                  <div
                    key={index}
                    className={`subImage ${index === activePhotoIndex ? 'isActive' : ''}`}
                    onClick={() => setActivePhotoIndex(index)}
                  >
                    <img src={imageURL} alt="" />
                  </div>
                ))}
              </div>
            </div>
            <div className="texts">
              <div className="planDetailTable">
                <div className="planDetailTableHeader">宿泊条件</div>
                <div className="planDetailTableBody">
                  <div className="planDetailTableBodyItem">
                    <div className="name">食事条件</div>
                    <div className="content">{mealCondition}</div>
                  </div>
                  <div className="planDetailTableBodyItem">
                    <div className="name">チェックイン</div>
                    <div className="content">
                      {checkInDisplay}
                    </div>
                  </div>
                  <div className="planDetailTableBodyItem">
                    <div className="name">チェックアウト</div>
                    <div className="content">
                      {checkOutDisplay}
                    </div>
                  </div>
                  <div className="planDetailTableBodyItem">
                    <div className="name">お部屋</div>
                    <div className="content">{roomTypeName}</div>
                  </div>
                  <div className="planDetailTableBodyItem">
                    <div className="name">定員</div>
                    <div className="content">{room && room.capacity && room.capacity.max}名</div>
                  </div>
                </div>
              </div>
              <div className="planDetailTagItems">
                {tags && tags.map((t) => {
                  const { id, name, tagGroup } = t;
                  if(tagGroup && 'name' in tagGroup){
                    if(tagGroup.name === '支払方法') {
                      return null;
                    }
                  }

                  return (
                    <div className="tagItem" key={id}>
                      <Tag>{name}</Tag>
                    </div>
                  );
                })}
                {mealCondition && (
                  <div className="tagItem" >
                    <Tag>{mealCondition}</Tag>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="planDetailText">
          {message && (
            <div className="warningText mobileMargin">
              <div className="warningTextTitle">施設に関するご案内・ご注意</div>
              <p dangerouslySetInnerHTML={{ __html: message }}/>
            </div>
          )}
          {recommendationPoint && <div className="planDetailTable" style={{ maxWidth: 'none' }}>
            <div className="planDetailTableBody" style={{ border: 'none' }}>
              <p
                className="text"
                dangerouslySetInnerHTML={{ __html: recommendationPoint }}
              />
            </div>
          </div>}
          {!!commentInfo && !!commentInfo.length && commentInfo.map((c, i) => (
            <div key={i} className="planDetailTable" style={{ maxWidth: 'none' }}>
              {!!c.title && (
                <div className="planDetailTableHeader">{c.title}</div>
              )}
              <div className="planDetailTableBody" style={{ borderBottom: 'none'}}>
                <p
                  className="text"
                  dangerouslySetInnerHTML={{ __html: c.comments }}
                />
              </div>
            </div>
          ))}
          {!!(mealInfo && !!mealInfo.length) && (
            <div className="planDetailTable" style={{ maxWidth: 'none' }}>
              {mealInfo.map((m, i) => (
                <div key={i} className="planDetailTableBody" style={{ border: 'none' }}>
                  <div className="text">
                    {`●${getMealDisplayFromMealCD(m.mealCD)}`}<br/>
                    {`【場所】${m.place}`}<br/>
                    【内容・備考】<br/>
                    <p className="withIndent" dangerouslySetInnerHTML={{ __html: m.info }}/><br/>
                    <p className="withIndent" dangerouslySetInnerHTML={{ __html: m.remarks }}/>
                  </div>
                </div>
              ))}
            </div>
          )}
          {!!omotenashiInfo && !!omotenashiInfo.length && omotenashiInfo.map((o, i) => (
            <div key={i} className="planDetailTable" style={{ maxWidth: 'none' }}>
              <div className="planDetailTableHeader">{o.title}</div>
              <div className="planDetailTableBody" style={{ borderBottom: 'none'}}>
                <p
                  className="text"
                  dangerouslySetInnerHTML={{ __html: o.contents }}
                />
              </div>
            </div>
          ))}
          {landingFlag ? (
            <React.Fragment>
              <LineTitleGray>タビサキMenu</LineTitleGray>
              <div className="planDetailPlanOptionBody">
                <LineTitle size="tiny">{subtitle}</LineTitle>
                <div className="explanationWrap" dangerouslySetInnerHTML={{ __html: explanation }} />
              </div>
            </React.Fragment>
          ) : null}
          <RoomDetail room={room} roomType={roomType} isWDS={isWDS} />
          <PlanInfo
            people={people}
            stayNights={Number(stayNights)}
            startDate={outbound.date}
            handleSelectButton={handleClickButton}
            totalAmount={totalAmount}
            adultPrice={adultPrice}
            stocks={stocks}
            editingAccommodation={editingAccommodation}
          />
        </div>
        <p className="remark" dangerouslySetInnerHTML={{ __html: chargesRemarks }} />
        <p className="remark" dangerouslySetInnerHTML={{ __html: chargesInfantRemarks }} />
        {handlePlanListLinkBottom && (
          <div className="planListBottom">
            <div className={`textLinkWrap clickable planListLink`}>
              <span className={`textLink`} onClick={handlePlanListLinkBottomSpan}>
                この施設のプラン一覧を見る
              </span>
            </div>
          </div>
        )}
        {guidance && (
          <div className="planDetailOther">
            <div className="planDetailTitle">
              <LineTitleGray>プランに関するご案内・ご注意</LineTitleGray>
            </div>
            <div className="planDetailOtherBody">
              <div className="planDetailOtherBodyText" dangerouslySetInnerHTML={{ __html: guidance }} />
            </div>
          </div>
        )}
        <PlanningInfo className="planDetailOther" info={planningImplementation} />
      </div>
      <ModalOtherPage
        open={showPlanDetailModal}
        onClose={onCloseDetailModal}
        srcUrl={planDetaillink}
      />
    </div>
  );
};

PlanDetail.propTypes = {
  handlePlanSelect: PropTypes.func,
  selectedPlan: PropTypes.object,
  hidePlanListLink: PropTypes.bool,
  handlePlanListLinkBottom: PropTypes.func,
  handlePlanListLink: PropTypes.func,
  editingAccommodation: PropTypes.bool,
};

export default PlanDetail;

const getMealDisplayFromMealCD = (mealCD) => {
  switch (mealCD) {
  case '1':
    return '朝食';
  case '2':
    return '昼食';
  case '3':
    return '夕食';
  }
};
